import React from 'react';
import { Grid, TextField } from '@mui/material';
import { UtilityService } from '../../../types/utility.types';

interface WasteFormProps {
  formData: UtilityService;
  handleFormChange: (field: string, value: any) => void;
  handleNestedChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isViewMode: boolean;
}

/**
 * Component for Waste contracts
 */
const WasteForm: React.FC<WasteFormProps> = ({
  formData,
  handleFormChange,
  handleNestedChange,
  isViewMode,
}) => {
  return (
    <Grid container spacing={3}>
      {/* Reference Number */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Reference Number"
          name="meterDetails.meterType"
          value={formData.meterDetails?.meterType || ''}
          onChange={handleNestedChange}
          disabled={Boolean(isViewMode)}
        />
      </Grid>
      
      {/* Collection Frequency */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Collection Frequency"
          name="meterDetails.location"
          value={formData.meterDetails?.location || ''}
          onChange={handleNestedChange}
          disabled={Boolean(isViewMode)}
        />
      </Grid>
      
      {/* Current Rate */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Current Rate"
          name="currentRate"
          value={formData.currentRate || ''}
          onChange={(e) => handleFormChange('currentRate', e.target.value)}
          disabled={Boolean(isViewMode)}
        />
      </Grid>
      
      {/* Contract Value */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Contract Value"
          name="contractValue"
          value={formData.contractValue || ''}
          onChange={(e) => {
            // Only allow numbers and decimal point
            const value = e.target.value;
            if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
              handleFormChange('contractValue', value);
            }
          }}
          disabled={Boolean(isViewMode)}
          InputProps={{
            startAdornment: <span style={{ marginRight: '4px' }}>£</span>,
          }}
          helperText="Enter contract value in pounds"
        />
      </Grid>
    </Grid>
  );
};

export default WasteForm;
